import styled from 'styled-components';

import { hexWithAlpha } from 'utils/colors';

import { ACCENT_TINT_BG_ALPHA, ACCENT_TINT_BORDER_ALPHA } from '../constants';

export const Panel = styled.div<LandingV2.AccentProp>`
  width: 100%;
  background: ${({ theme, $accentColor }) =>
    $accentColor ? hexWithAlpha($accentColor, ACCENT_TINT_BG_ALPHA) : theme.colors.successBg};
  border: 0.1rem solid
    ${({ theme, $accentColor }) =>
      $accentColor ? hexWithAlpha($accentColor, ACCENT_TINT_BORDER_ALPHA) : theme.colors.successBorder};
  border-radius: 1.6rem;
  padding: 2.2rem 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-top: 0.6rem;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;
`;

export const CountRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 1rem;
`;

export const CountValue = styled.div<LandingV2.AccentProp>`
  font-size: 1.8rem;
  font-weight: 900;
  color: ${({ theme, $accentColor }) => $accentColor || theme.colors.successText};
`;

export const Label = styled.div<LandingV2.AccentProp>`
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
  color: ${({ theme, $accentColor }) => $accentColor || theme.colors.successText};
`;

export const Divider = styled.div<LandingV2.AccentProp>`
  height: 0.1rem;
  background: ${({ theme, $accentColor }) =>
    $accentColor ? hexWithAlpha($accentColor, ACCENT_TINT_BORDER_ALPHA) : theme.colors.successBorder};
`;

export const ScoreRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.4rem;
`;

export const Score = styled.div<LandingV2.AccentProp>`
  font-size: 2.8rem;
  font-weight: 900;
  line-height: 0.9;
  letter-spacing: -0.04rem;
  color: ${({ theme, $accentColor }) => $accentColor || theme.colors.greenCta};
`;

export const ScoreDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const Stars = styled.div`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.amber};
  letter-spacing: 0.3rem;
`;

export const ReviewCount = styled.div<LandingV2.AccentProp>`
  font-size: 1.1rem;
  color: ${({ theme, $accentColor }) => $accentColor || theme.colors.successDark};
`;
